function _escapeHtml(value: unknown): string {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function _sanitizeString(value: unknown): string {
  if (value === null || value === undefined) {
    return "";
  }
  return _escapeHtml(value);
}

function _convertLineBreaks(original = ""): string {
  return original
    .replaceAll(/\r\n/g, "<br>")
    .replaceAll(/\r/g, "<br>")
    .replaceAll(/\n/g, "<br>");
}

export function buildKeywordHighlightHtml(original: string, keywords: string[] = []): string {
  if (typeof original !== "string" || original.length === 0) {
    return "";
  }
  let sanitized = _sanitizeString(original);
  if (!Array.isArray(keywords) || keywords.length === 0) {
    return _convertLineBreaks(sanitized);
  }
  keywords.forEach((keyword) => {
    if (typeof keyword !== "string" || keyword.length === 0) {
      return;
    }
    const sanitizedKeyword = _sanitizeString(keyword);
    sanitized = sanitized.replaceAll(sanitizedKeyword, `<em>${sanitizedKeyword}</em>`);
  });
  return _convertLineBreaks(sanitized);
}